// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure the entire app takes up the full viewport without overflow */
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden; /* Hides both vertical and horizontal scrollbars */
  height: 100%;
  width: 100%;
}

.app {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden; /* Prevents scrollbars within the app itself */
}

.side-menu {
  width: 10%;
  padding: 1rem;
  background-color: #d2d2d2;
  border-right: 2px solid #ccc;
  /*overflow: hidden; /* Ensures no scrollbars appear inside the side menu */
}


@media only screen and (max-width: 768px) {
  .side-menu {
    width: 77%;
    padding: 1rem;
    background-color: #d2d2d2;
    border-right: 2px solid #ccc;
    /*overflow: hidden; /* Ensures no scrollbars appear inside the side menu */
  }
}

.canvas {
  flex-grow: 1;
  background-color: #ffffff;
  overflow: hidden; /* Prevents any accidental scrollbars inside the canvas */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,sEAAsE;AACtE;EACE,SAAS;EACT,UAAU;EACV,gBAAgB,EAAE,kDAAkD;EACpE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,gBAAgB,EAAE,8CAA8C;AAClE;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,4BAA4B;EAC5B,0EAA0E;AAC5E;;;AAGA;EACE;IACE,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,4BAA4B;IAC5B,0EAA0E;EAC5E;AACF;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,gBAAgB,EAAE,yDAAyD;AAC7E","sourcesContent":["/* Ensure the entire app takes up the full viewport without overflow */\nhtml, body {\n  margin: 0;\n  padding: 0;\n  overflow: hidden; /* Hides both vertical and horizontal scrollbars */\n  height: 100%;\n  width: 100%;\n}\n\n.app {\n  display: flex;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden; /* Prevents scrollbars within the app itself */\n}\n\n.side-menu {\n  width: 10%;\n  padding: 1rem;\n  background-color: #d2d2d2;\n  border-right: 2px solid #ccc;\n  /*overflow: hidden; /* Ensures no scrollbars appear inside the side menu */\n}\n\n\n@media only screen and (max-width: 768px) {\n  .side-menu {\n    width: 77%;\n    padding: 1rem;\n    background-color: #d2d2d2;\n    border-right: 2px solid #ccc;\n    /*overflow: hidden; /* Ensures no scrollbars appear inside the side menu */\n  }\n}\n\n.canvas {\n  flex-grow: 1;\n  background-color: #ffffff;\n  overflow: hidden; /* Prevents any accidental scrollbars inside the canvas */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
